import { msToMMSS } from '~/js/utilities';

const videoLibraryPlayer = (initialVideoBlock) => ({
  selectedVideoBlock: {
    ...initialVideoBlock.video,
    title: initialVideoBlock.title,
  },
  videoEl: null,
  isPlaying: false,
  wantsAutoplay: false, // masks display of info overlay when user wants to load and immediately play another video
  cursorOnVideo: false,
  touchDeviceDetected: false,
  timeRemaining: false,

  init() {
    this.videoEl = this.$refs.videoEl;
    this.timeRemaining = this.duration;

    this.$watch('wantsAutoplay', (wantsAutoplay) => {
      if (wantsAutoplay) {
        this.videoEl.setAttribute('autoplay', 'true');
      } else {
        this.videoEl.removeAttribute('autoplay');
      }
    });

    this.updateTimeRemaining = this.updateTimeRemaining.bind(this);
    this.videoEl.addEventListener('timeupdate', this.updateTimeRemaining);
  },

  handlePlayPauseClick() {
    this.isPlaying ? this.videoEl.pause() : this.videoEl.play();
  },

  handlePauseClick() {
    this.videoEl.pause();
  },

  handleTouchStart() {
    /**
     * Override previous mouseEnter event
     * which is unintentionally triggered by touch event
     * prevent it from happening again
     */
    this.cursorOnVideo = false;
    this.touchDeviceDetected = true;
  },

  handleMouseEnter() {
    if (!this.touchDeviceDetected) this.cursorOnVideo = true;
  },

  handleMouseLeave() {
    if (!this.touchDeviceDetected) this.cursorOnVideo = false;
  },

  handleSelectVideo({ detail }) {
    const { videoBlock, playOnLoad } = detail;
    this.selectedVideoBlock = videoBlock;
    this.videoEl.load();
    this.wantsAutoplay = playOnLoad;
  },

  /* Handlers on video element */
  handlePlayEvent() {
    this.isPlaying = true;
    // unset wantsAutoplay masks info overlay
    // to restore visibility of info overlay on mouseenter
    this.wantsAutoplay = false;
  },

  handlePauseEvent() {
    this.isPlaying = false;
  },

  handleLoadStartEvent() {
    this.isPlaying = false;
  },

  updateTimeRemaining() {
    this.timeRemaining = this.duration;
  },

  get displayInfoOverlay() {
    const { isPlaying, wantsAutoplay, cursorOnVideo } = this;
    return (!isPlaying && !wantsAutoplay) || cursorOnVideo;
  },

  get duration() {
    const duration = this.selectedVideoBlock.duration;
    const currentTime = (this.videoEl.currentTime || 0) * 1000;
    const remaining = duration - currentTime;
    return msToMMSS(remaining);
  },
});

export default videoLibraryPlayer;
